import axios from "axios";
import { authenticatedApiConfig } from "./BaseApiService";
import { ApiResult } from "healthex-common/result";
import { plainToInstance } from "class-transformer";
import { StudyDto, PatientFacingDetailsDto } from "healthex-common/study.dtos";
export class ProtocolIngestionService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async getStudyProtocolFormUploadUrl(orgId, studyId, file) {
        const localFileInfo = { filename: file.name };
        const response = await axios.put(`${this.environment.API_BASE_URL}/organizations/${orgId}/studies/${studyId}/protocol-document-upload-url`, localFileInfo, authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getClinicalStudyFromUploadedDocument(orgId, studyId, fileName, abortController) {
        var _a;
        try {
            const response = await axios.post(`${this.environment.API_BASE_URL}/organizations/${orgId}/studies/${studyId}/study-protocol/$import`, { fileName }, {
                ...authenticatedApiConfig(this.authenticationProvider),
                signal: abortController.signal,
            });
            return new ApiResult(plainToInstance(StudyDto, response.data));
        }
        catch (e) {
            if (axios.isCancel(e)) {
                console.log("Request canceled", e.message);
                return new ApiResult(null, ["REQUEST_CANCELED"]);
            }
            console.log("Error in importing study from the uploaded doc", e);
            if (axios.isAxiosError(e) && ((_a = e.response) === null || _a === void 0 ? void 0 : _a.data)) {
                const errorData = e.response.data;
                if (errorData.message && errorData.statusCode && errorData.statusCode === 400) {
                    return new ApiResult(null, [errorData.message.toString()]);
                }
            }
            return null;
        }
    }
    async getStudyProtocolDownloadUrl(orgId, studyId, fileName, inline, studyDraft = false) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/organizations/${orgId}/studies/${studyId}/study-protocol-document-download-url/${fileName}`, {
            ...authenticatedApiConfig(this.authenticationProvider),
            params: { inline, studyDraft },
        });
        return response.data;
    }
    async getICFFormUploadUrl(orgId, studyId, file) {
        const localFileInfo = { filename: file.name };
        const response = await axios.put(`${this.environment.API_BASE_URL}/organizations/${orgId}/studies/${studyId}/icf-protocol-document-upload-url`, localFileInfo, authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getICFFormDownloadUrl(orgId, studyId, fileName, inline, studyDraft = false) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/organizations/${orgId}/studies/${studyId}/icf-protocol-document-download-url/${fileName}`, {
            ...authenticatedApiConfig(this.authenticationProvider),
            params: { inline, studyDraft },
        });
        return response.data;
    }
    async getExtractedPatientFacingDetailsFromUploadedDocument(orgId, studyId, fileName, abortController) {
        var _a;
        try {
            const response = await axios.post(`${this.environment.API_BASE_URL}/organizations/${orgId}/studies/${studyId}/icf-protocol/$import`, { fileName }, {
                ...authenticatedApiConfig(this.authenticationProvider),
                signal: abortController.signal,
            });
            return new ApiResult(plainToInstance(PatientFacingDetailsDto, response.data));
        }
        catch (e) {
            if (axios.isCancel(e)) {
                console.log("Request canceled", e.message);
                return new ApiResult(null, ["REQUEST_CANCELED"]);
            }
            console.log("Error in importing study from the uploaded doc", e);
            if (axios.isAxiosError(e) && ((_a = e.response) === null || _a === void 0 ? void 0 : _a.data)) {
                const errorData = e.response.data;
                if (errorData.message && errorData.statusCode && errorData.statusCode === 400) {
                    return new ApiResult(null, [errorData.message.toString()]);
                }
            }
            return null;
        }
    }
    async deleteProtocolUploadedDocument(orgId, studyId, filename, type, options) {
        await axios.delete(`${this.environment.API_BASE_URL}/organizations/${orgId}/studies/${studyId}/${type}/${filename}/delete`, {
            ...authenticatedApiConfig(this.authenticationProvider),
            params: options,
        });
    }
    async batchUpdateStatusToActive(orgId, studyId, sectionType) {
        await axios.put(`${this.environment.API_BASE_URL}/organizations/${orgId}/studies/${studyId}/section-images/${sectionType}/batch-update-status-to-active`, {}, authenticatedApiConfig(this.authenticationProvider));
    }
}
